module.exports = __webpack_public_path__ + "img/Gallery_3_11.ba8c2285.jpeg";